var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('app-primary', {
    scopedSlots: _vm._u([{
      key: "contentsHead",
      fn: function () {
        return [_c('sub-head-primary', {
          attrs: {
            "itemTitle": "단지안내",
            "tabActive": "층별 호수 배치도",
            "bg": "/images/sub/complex/visual.jpg"
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function () {
              return [_vm._v("단지안내")];
            },
            proxy: true
          }])
        })];
      },
      proxy: true
    }])
  }, [_c('page-section-primary', {
    staticClass: "page-section--first page-section--last",
    attrs: {
      "titWrapClass": "text-center"
    },
    scopedSlots: _vm._u([{
      key: "tit",
      fn: function () {
        return [_vm._v("층별 호수 배치도")];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "download-button"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "justify": "end"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4",
      "lg": "2"
    }
  }, [_c('v-row', {
    staticClass: "row--xxs"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    staticClass: "rounded-pill",
    attrs: {
      "block": "",
      "color": "primary",
      "outlined": "",
      "href": "/res/download/floor-room.zip",
      "download": "층별 호수 보기"
    }
  }, [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("층별 호수 보기")])])], 1)], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "page-section__content"
  }, [_c('div', {
    staticClass: "floor-tabs"
  }, [_c('v-tabs', {
    staticClass: "v-tabs--density-compact",
    attrs: {
      "grow": "",
      "hide-slider": "",
      "centered": ""
    },
    model: {
      value: _vm.tab,
      callback: function ($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_vm._l(_vm.items, function (item, index) {
    return [_c('tab-quarternary', {
      key: index
    }, [_vm._v(_vm._s(item) + "층")])];
  })], 2)], 1)]), _c('div', {
    staticClass: "page-section__content"
  }, [_c('sheet-secondary', {
    staticClass: "pa-0",
    attrs: {
      "min-height": "400",
      "align": "center"
    }
  }, [_c('v-tabs-items', {
    model: {
      value: _vm.tab,
      callback: function ($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_vm._l(_vm.items, function (item, index) {
    return [_c('v-tab-item', {
      key: index,
      attrs: {
        "eager": ""
      }
    }, [_c('img', {
      attrs: {
        "src": `/images/sub/complex/floor/floor-${item}.jpg`,
        "alt": ""
      }
    })])];
  })], 2)], 1)], 1)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }